import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";

@Component({
	selector: "app-general-store-setup",
	templateUrl: "./general-store-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class GeneralStoreSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	timestamp = new Date().getTime();

	timezones = moment.tz.zonesForCountry("US").map((tz) => ({
		label: tz,
		value: tz,
	}));

	constructor(public app: AppService, public venueService: OOVenueService, public imgCrop: ImageCropperService) {}

	ngOnInit(): void {}

	async selectImage(source) {
		this.imgCrop.openImageCropper(source, undefined, this.venueService.venueKey);
		this.imgCrop.imageCroppingComplete.subscribe((data) => (this.timestamp = data));
	}
}
